import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { AuthScreen } from "@/components/AuthScreen";
import { OrbTabApp } from "@/components/OrbTabApp";

export const Route = createFileRoute("/")({
  component: Page,
});

function Page() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        className="min-h-screen grid place-items-center text-white"
        style={{ background: "linear-gradient(135deg,#0f172a,#312e81 60%,#7c3aed)" }}
      >
        <div className="animate-pulse">Orb Tab yükleniyor...</div>
      </div>
    );
  }
  return user ? <OrbTabApp user={user} /> : <AuthScreen />;
}
